import React, { useState } from 'react'
import { Stack } from '@mui/material'
import { useTranslation } from 'react-i18next'

import { useUser } from 'store'
import {
  getEquipmentTopologyStatus,
  TOPOLOGY_TOOLTIP_KEYS,
  useNavigateToEquipmentMap,
  useNavigateToEquipmentTopology
} from '../../use-actions'
import Pictures from '../modales/Pictures'
import { InfoRow, SoftButton, Widget } from './Widget'

const detailsRows = (equipment, t) => [
  [t('supervision.card.account'), equipment.site?.account_parent?.name],
  [t('supervision.card.site'), equipment.site?.name],
  [t('supervision.card.building'), equipment.building_name],
  [t('supervision.card.level'), equipment.floor_name],
  [t('supervision.card.manufacturer'), equipment.manufacturer],
  [t('supervision.card.model'), equipment.model],
  [t('supervision.card.mac_address'), equipment.mac],
  [t('supervision.card.ip_address'), equipment.ip_address]
]

const DetailsWidget = ({ equipment, topology, topologyLoading }) => {
  const { t } = useTranslation()
  const [user] = useUser()
  const [picturesOpen, setPicturesOpen] = useState(false)
  const { navigateToMap, loading: mapLoading } = useNavigateToEquipmentMap(equipment)
  const { navigateToTopology } = useNavigateToEquipmentTopology(equipment, topology)
  const topologyStatus = getEquipmentTopologyStatus({
    loading: topologyLoading,
    topology,
    mac: equipment?.mac
  })
  const canSeeTopology = user?.admin || user?.roles?.topology
  const handleOpenPictures = () => setPicturesOpen(true)
  const handleClosePictures = () => setPicturesOpen(false)

  return (
    <>
      <Widget
        icon="fa-light fa-info"
        title={t('supervision.hardware.detail.details')}
        action={
          <SoftButton icon="fa-light fa-eye" onClick={handleOpenPictures}>
            {t('supervision.hardware.detail.photos')}
          </SoftButton>
        }>
        <Stack gap={0.75} sx={{ flex: 1 }}>
          {detailsRows(equipment, t).map(([label, value]) => (
            <InfoRow key={label} label={label} value={value} />
          ))}
        </Stack>
        <Stack direction={{ xs: 'column', md: 'row' }} justifyContent="space-between" gap={1} mt={2}>
          <SoftButton onClick={navigateToMap} disabled={mapLoading} fullWidthOnMobile>
            {t('supervision.hardware.detail.locate_map')}
          </SoftButton>
          {
            canSeeTopology && (
              <SoftButton
                onClick={navigateToTopology}
                disabled={topologyStatus !== 'available'}
                tooltip={t(TOPOLOGY_TOOLTIP_KEYS[topologyStatus])}
                fullWidthOnMobile>
                {t('supervision.hardware.detail.locate_topology')}
              </SoftButton>
            )
          }
        </Stack>
      </Widget>
      <Pictures open={picturesOpen} onClose={handleClosePictures} uuid={equipment?.uuid} />
    </>
  )
}

export default DetailsWidget
